import template from './register.html';
import controller from './register.controller';
import './register.scss';

let RegisterComponent = {
  bindings: {},
  template,
  controller
};

export default RegisterComponent;



// WEBPACK FOOTER //
// ./src/app/pages/register/register.component.js